import type { ChromeCopy } from '../types/chrome';

export const chromeFr: ChromeCopy = {
  siteMeta: {
    defaultTitle: 'SafestMenu - Menus QR code pour restaurants | safestmenu.com',
    defaultDescription:
      'Créez avec SafestMenu sur safestmenu.com un menu QR code numérique et multilingue. Vos clients scannent; vous actualisez les prix. Démarrez gratuitement.',
  },
  header: {
    homeAriaLabel: 'Accueil SafestMenu',
    mainNavAriaLabel: 'Principal',
    mobileNavAriaLabel: 'Mobile',
    nav: {
      why: 'Pourquoi SafestMenu',
      howItWorks: 'Comment ça marche',
      aboutUs: 'À propos',
    },
    ctaLabel: 'Ouvrir l’application',
    openMenuAriaLabel: 'Ouvrir le menu',
    closeMenuAriaLabel: 'Fermer le menu',
  },
  footer: {
    tagline:
      'Le menu QR code pour restaurants, cafés et bars. Facile à mettre en place, sûr pour vos clients, respectueux de la nature.',
    siteNavAriaLabel: 'Site',
    legalNavAriaLabel: 'Légal',
    exploreHeading: 'Explorer',
    companyHeading: 'Entreprise',
    nav: {
      why: 'Pourquoi SafestMenu',
      howItWorks: 'Comment ça marche',
      allergenGuide: 'Guide des allergènes de l’UE',
      blog: 'Blog',
      openApp: 'Ouvrir l’application',
      aboutUs: 'À propos',
      impressum: 'Impressum',
      terms: 'Conditions générales',
      transfactorDev: 'transfactor.dev',
    },
    craftedBy: 'Conçu par',
    copyrightSuffix: 'SafestMenu. Tous droits réservés.',
  },
  consent: {
    message:
      'Nous utilisons des cookies à des fins d’analyse et pour mesurer les performances publicitaires. Vous pouvez accepter ou refuser - le site fonctionne de la même façon dans les deux cas. Nous ne les utilisons pas pour personnaliser les publicités.',
    decline: 'Refuser',
    accept: 'Accepter',
    settings: 'Paramètres des cookies',
  },
  languageSwitcher: {
    label: 'Changer de langue',
  },
  localeSuggestion: {
    message: 'Cette page est aussi disponible en français.',
    accept: 'Voir en français',
    dismiss: 'Non merci',
  },
  emailCapture: {
    defaultTitle: 'Recevez des conseils sur les menus dans votre boîte mail',
    defaultDescription:
      'Quelques conseils pratiques, de temps en temps, sur les menus, les allergènes et la gestion d’un restaurant sans papier. Pas de spam.',
    defaultPlaceholder: 'vous@restaurant.com',
    defaultButtonLabel: 'S’abonner',
    emailLabel: 'Adresse e-mail',
    loadingButtonLabel: 'Inscription en cours…',
    successMessage:
      'Vous êtes inscrit. Surveillez votre boîte mail pour recevoir des conseils sur les menus.',
    errorMessage: 'Une erreur s’est produite. Veuillez réessayer dans un instant.',
  },
  qrPlate: {
    linkAriaLabel: 'Scannez ou touchez pour ouvrir la démo en direct de SafestMenu',
    svgAriaLabelPrefix: 'QR code menant à ',
    caption: 'Scannez ou cliquez - c’est bien réel',
  },
  notFound: {
    seoTitle: 'Page introuvable',
    heading: 'Ce plat n’est pas au menu.',
    message: 'La page que vous recherchez n’existe pas ou a été déplacée.',
    backLabel: 'Retour au menu',
  },
  blog: {
    seoTitle: 'Blog',
    seoDescription:
      'Des conseils pratiques sur les menus QR code, l’expérience client et la gestion d’un restaurant sans papier.',
    eyebrow: 'Blog',
    heading: 'Réflexions sur les menus, les clients et la gestion d’un restaurant sans papier.',
    emptyMessage: 'De nouveaux articles arrivent bientôt.',
  },
};
